<script setup lang="ts">
import { Vue3ColorPicker } from '@cyhnkckali/vue3-color-picker'
import '@cyhnkckali/vue3-color-picker/dist/style.css'
import { onMounted, onUnmounted, ref, useSlots } from 'vue'

import { BoxComponent, InputComponent } from '@/ui-library'

withDefaults(
  defineProps<{
    placeholder?: string
    size?: 'default' | 'small' | 'large'
    name?: string
  }>(),
  {
    placeholder: '',
    size: 'default',
    name: undefined,
  },
)

const slots = useSlots()
const value = defineModel<string>('modelValue', { default: '' })
defineEmits(['change', 'input'])

const isColorPickerOpen = ref(false)
const colorPickerContainer = ref<HTMLElement | null>(null)

const handleOutsidePickerClick = (event: MouseEvent) => {
  if (isColorPickerOpen.value && !colorPickerContainer.value?.contains(event.target as Node)) {
    isColorPickerOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleOutsidePickerClick)
})
onUnmounted(() => {
  document.removeEventListener('click', handleOutsidePickerClick)
})
</script>

<template>
  <div class="color-picker">
    <div v-if="slots.header">
      <BoxComponent :mb="8">
        <slot name="header" />
      </BoxComponent>
    </div>
    <div class="color-picker__input">
      <div ref="colorPickerContainer">
        <button type="button" class="color-picker__button" @click="isColorPickerOpen = !isColorPickerOpen" />
        <div class="color-picker__picker">
          <Vue3ColorPicker
            v-if="isColorPickerOpen"
            v-model="value"
            mode="solid"
            type="HEX"
            input-type="RGB"
            :show-alpha="false"
            :show-color-list="false"
            :show-input-menu="false"
            :show-picker-mode="false"
          />
        </div>
      </div>
      <InputComponent v-model="value" :placeholder="placeholder" :name="name" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.color-picker {
  position: relative;
  width: 100%;
}

.color-picker__picker {
  position: absolute;
  top: -60px;
  left: 0;
  z-index: 2;
}

.color-picker__input {
  position: relative;
}

.color-picker__button {
  position: absolute;
  top: 1px;
  left: 1px;
  z-index: 1;

  height: 54px;
  width: 54px;

  border: none;
  border-right: 1px solid var(--secondary-12);
  border-radius: 8px 0 0 8px;
  background-color: v-bind(value);
  cursor: pointer;
}

:deep(.el-input__wrapper) {
  padding-left: 70px;
}
</style>
